import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-data-foundations }}",{ moduleName: "embercom/components/modal/company-delete.hbs" })